/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Lifecycle status of the owning federation.
 */
export type FederationStatus = (typeof FederationStatus)[keyof typeof FederationStatus];

export const FederationStatus = {
  Active: "Active",
  Inactive: "Inactive",
} as const;
